import React from "react"

interface PageFooterProps {
  className?: string
}

const PageFooter: React.FC<PageFooterProps> = ({ className = "" }) => {
  return (
    <div className={`page-footer ${className}`}>
      <div className="page-footer-divider"></div>
      <div className="page-footer-text">
        The above information was provided by SS&C Technologies.
        <br />
        Quadrant Private Capital Solutions believes this information to be
        reliable but does not guarantee its accuracy.
      </div>
    </div>
  )
}

export default PageFooter
